import { Controller } from "@hotwired/stimulus"

// No class on <html> means "follow the system". Choosing a theme sets html.light or html.dark and
// remembers it in a cookie, so the server renders the same class on the next request.
export default class extends Controller {
  connect() {
    const saved = document.cookie.match(/theme=(light|dark)/)?.[1]
    if (saved) this.apply(saved)
  }

  toggle() {
    const next = this.effective() === "dark" ? "light" : "dark"
    this.apply(next)
    document.cookie = `theme=${next};path=/;max-age=31536000`
  }

  // What the person is looking at right now
  effective() {
    const html = document.documentElement
    if (html.classList.contains("dark")) return "dark"
    if (html.classList.contains("light")) return "light"
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
  }

  apply(theme) {
    const html = document.documentElement
    html.classList.remove("light", "dark")
    html.classList.add(theme)
  }
}
